import { type FC } from 'react'
import { type SchedulingEventType } from '../../../models/Scheduling'

export const EventTypeChip: FC<{ eventType?: SchedulingEventType }> = ({ eventType }) =>
  eventType ? (
    <span className='paragraph-small zocks-text-gray-600'>
      {eventType.name} · {eventType.durationMinutes} min
    </span>
  ) : null
